import { render, staticRenderFns } from "./ModalFloatingFeedback.vue?vue&type=template&id=2187efa6&scoped=true&"
import script from "./ModalFloatingFeedback.vue?vue&type=script&lang=js&"
export * from "./ModalFloatingFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2187efa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2187efa6')) {
      api.createRecord('2187efa6', component.options)
    } else {
      api.reload('2187efa6', component.options)
    }
    module.hot.accept("./ModalFloatingFeedback.vue?vue&type=template&id=2187efa6&scoped=true&", function () {
      api.rerender('2187efa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/ModalFloatingFeedback.vue"
export default component.exports